import axios from 'axios'
import store from '@/store'
import login from '@/components/login/login.js';
import { refresh } from '@/apis/user';

const service = axios.create({
    // url = base url + request url
    baseURL: process.env.VUE_APP_BASE_API,
    // send cookies when cross-domain requests
    // withCredentials: true,
    // request timeout,
    timeout: 50000,
});

// 當前是否正在刷新 token 的標誌
let isRefreshing = false

// 待重試請求隊列
let requestsQueue = []



// 請求攔截器 (添加 token)
service.interceptors.request.use(
    config => {
        // 檢查會否是免認證接口
        if (!config.noAuth) {
            const token = store.state.token
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// 響應攔截器 (處理 token 過期)
service.interceptors.response.use(
    //response => response,
    async response => {
        const { config, data } = response
        if (!config.noAuth && data.code == 1001) {
            console.log('error 1001')
            //store.dispatch('logout');
            if(location.pathname != '/'){
                location.href = '/';
            }
            login.open();
            return;
        }
        return Promise.resolve(data);
    },
    async error => {
        const { config, response } = error
        const originalRequest = config
        // 檢測 token 過期 (狀態碼 401)
        if (!config.noAuth || (response.status === 401 && !originalRequest._retry)) {
            originalRequest._retry = true;
            //如果正在刷新，將請求加入隊列等待
            // if (isRefreshing) {
            //     return new Promise(resolve => {
            //         requestsQueue.push(() => resolve(service(originalRequest)))
            //     })
            // }

            // isRefreshing = true;

            // try {
            //     // 請求刷新API
            //     const { data } = await refresh(store.state.refreshToken);

            //     // 更新存儲中的 token
            //     const newToken = data.accessToken
            //     store.commit('UPDATE_TOKEN', newToken)

            //     // 重放所有隊列中的請求
            //     requestsQueue.forEach(cb => cb(newToken))
            //     requestsQueue = []

            //     // 重新發送當前請求
            //     originalRequest.headers.Authorization = `Bearer ${newToken}`
            //     return service(originalRequest)

            // } catch (refreshError) {
            //     //刷新失敗處理 (跳轉至登錄)
            //     store.dispatch('logout')
            //     return Promise.reject(refreshError)
            // } finally {
            //     isRefreshing = false
            // }
        }
        return Promise.reject(error)
    }
)


export default service